import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dollar",
  "use": "icon-dollar-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-dollar\">\n                  <!-- 黄色圆形 -->\n                  <circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#F2DE2C\" />\n                  <text x=\"10\" y=\"12\" font-size=\"18\" font-family=\"Arial, sans-serif\" fill=\"white\" text-anchor=\"middle\" dominant-baseline=\"middle\">\n                    S\n                  </text>\n                </symbol>"
});
var result = sprite.add(symbol);
export default symbol